import React, { PureComponent } from "react";

import message01 from 'images/soldier/message1.png';
import { Link } from "react-router-dom";
require ("./deucationTrainingPolicyDetail.css");
export default class DeucationTrainingPolicyDetail extends PureComponent {

    render() {
        return (
            <div>
                {/* 详情 */}
                <div className="details">
                    <div className="container">
                        <div className="details_title">融融暖意，激发练兵动力：各地拥军优抚法治化 </div>
                        <div className="details_tips">
                            <span>信息来源：中国军网综合</span>
                            <span>发布日期：2019-12-20</span>
                        </div>
                        <div className="details_cont">
                            <div className="details_cont_text">
                                <p>党的十九大提出“让军人成为全社会尊崇的职业”。为使拥军优抚走向制度化、法治化，不少省份在落实国家一系列关于军人荣誉感的政策法规、重大部署和激励措施的基础上，以地方立法形式先后出台了多种举措，推动拥军优抚工作创新发展；全国民航、铁路系统以及更多的领域和系统推行“军人依法优先”，主动为军人军属、退役军人提供服务，帮助解决实际问题。这些带着感情温度的举措，在社会上营造了尊崇军人的良好氛围。</p>
                                <p>让军人成为全社会尊崇的职业”需要一种社会氛围，要靠每一位社会成员共同营造。战争年代，军人奋不顾身浴血奋战，换来国家独立人民自由；和平时期，军人枕戈待旦练兵备战，换来生活安宁国家发展。在法治精神越来越深入人心的今天，强调“依法”二字，为“全社会尊崇”提供了法规制度上的遵循</p>
                                <p>“暖心是一种巨大的力量。”健全完善拥军优抚安置政策，破解退役军人安置、随军家属就业、军人子女入学和伤病残军人接收等难题，解除他们的后顾之忧，才能不断激发官兵强军兴军的激情，把党和人民的关爱化作练兵备战的动力，为实现党在新时代的强军目标奉献拼搏、不懈奋斗。</p>
                                <p>请关注今天出版的《解放军报》的报道——</p>
                                <img src={message01} />
                                <p>接到转隶通知的时候，我和家属最担心的就是孩子的上学问题，没想到一到新单位，省军区和省教育厅就安排好了相关事宜，打消了我们的顾虑。”新年前夕，中部战区陆军政治工作部李干事从学校接完孩子后，欣喜地对记者说。据悉，这是河北省出台《〈军人子女教育优待办法〉实施细则》，有效推进拥军优属政策改革取得的可喜成效。</p>
                                <p>随着国防和军队改革不断深入，部队移防搬迁、官兵分流转岗越来越频繁，做好军人子女优教工作显得尤为重要。”河北省军区政治工作局干事陈金勇介绍，为解决好军娃入学问题，省军区党委早准备、早筹划，多次赴石家庄、张家口等地听取驻军官兵建议，与地方有关部门协调，反复对草案进行修改，最终从顶层设计上出台法规性文件，让官兵不再为子女上学分心走神。</p>
                                <p>翻阅这份《细则》，记者发现其在学前教育、义务教育、报考高等学校等5个方面做了具体规定，明确军人因工作变动等，其子女需要转学、借读的，当地教育部门和学校要第一时间办理相关手续；军人子女就读公办幼儿园、小学、初中时，免交国家和地方规定外的任何费用；教育部门在坚持就近就便入学的同时，要根据学生学习情况，协调安排教育质量较好的学校。</p>
                                <p>记者了解到，近年来，该省军区各级坚持把军人子女教育优待作为一项重要议题，常抓常议，始终保持军地合力推进的强劲态势。他们充分发挥省军区桥梁纽带作用，定期了解汇总驻军官兵意见建议。为确保好政策落到实处，他们还注重跟踪抓好督导，确保符合条件的军人子女一人不漏、按时入学。</p>
                                <p>刚性措施作出硬性规范，子女入学实现一路绿灯。近年来，河北省军区联合教育部门主动和驻军官兵对接，在落实军人子女教育优待问题上已经惠及4000余人。</p>
                            </div>
                            <div className="details_cont_accessory">
                                <div>附件1：<a href="#">附件1：2018年退役军人登记表.doc</a></div>
                                <div>附件2：<a href="#">附件1：退役军人安置计划.doc</a></div>
                            </div>
                            <div className="flip">
                                <div>上一篇：<a href="javascript:;">没有文章了</a></div>
                                <div>下一篇：<a href="#">《退役军人保障法（草案）》</a></div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* 详情 */}
            </div>
        );
    }
}
